import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import StockStatus from '@prisjakt/ui-stock-status';
import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { StockStatusStates } from '@prisjakt/ui-stock-status/src/types';
import Icon from './components/stock-status-icon';
import * as S from './styles';

type OwnProps = {
  className?: string;
  status?: StockStatusStates | null;
  statusText?: string | null;
  toneDown?: boolean;
  showLabel?: boolean;
};

const Label: React.FC = props => {
  return (
    <S.MediumUp>
      <CaptionText emphasis={FontEmphasis.MEDIUM}>{props.children}</CaptionText>
    </S.MediumUp>
  );
};

const StockInfo = ({
  className,
  status,
  statusText,
  toneDown = false,
  showLabel = true,
}: OwnProps) => {
  const { t } = useContext(AppContext);
  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t(
        'product',
        `stock-status.${status ||
          'unknown'}` as keyof ParamsAndReturnTypes['product']
      );

  return (
    <S.BadgeWrapper className={className}>
      <S.Badge>
        <Icon
          icon={
            <StockStatus
              status={status}
              toneDown={toneDown}
              tooltip={processedStatusText as string}
              tooltipPlacement="top"
            />
          }
        />
        {showLabel && <Label>{processedStatusText}</Label>}
      </S.Badge>
    </S.BadgeWrapper>
  );
};

export default StockInfo;
